export default __webpack_public_path__ + "static/media/textalign-center.c3d33a92.svg";